import { createContext, Suspense, useEffect, useRef, useState } from "react";
import { useLocation, useOutlet } from "react-router-dom";
import { Helmet } from "react-helmet-async"; // добавьте это
import Cookies from "js-cookie";
import Header from "../components/header/Header";
import Footer from "../components/footer/Footer";
import PageLoad from "./../components/pageLoad/PageLoad";
import ModalWindow from "../components/modalWindow/ModalWindow";
import { CSSTransition, SwitchTransition } from "react-transition-group";
import Analytics from "components/analytics/analytics";

export const MainLayoutContext = createContext();

const MainLayout = () => {
  const currentOutlet = useOutlet();
  const ref = useRef(null);
  const location = useLocation();
  const [mobileMenu, setMobileMenu] = useState(null);

  // Проверка куки
  const hasCookie = Cookies.get("primpivoVisitor");
  const [isOpen, setIsOpen] = useState({
    policy: false,
    agreement: !hasCookie,
  });


  // Скролл наверх
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // Куки после закрытия модалки
  useEffect(() => {
    if (!isOpen.agreement && !Cookies.get("primpivoVisitor")) {
      Cookies.set("primpivoVisitor", "true", { expires: 1 / 48 });
    }
  }, [isOpen.agreement]);

  // Блокировка скролла при открытых модалках
  useEffect(() => {
    const isAnyModalOpen =
      Object.values(isOpen).some((elem) => elem) || mobileMenu;
    document.body.style.overflow = isAnyModalOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen, mobileMenu]);

  return (
    <MainLayoutContext.Provider
      value={{
        isOpen,
        setIsOpen,
        mobileMenu,
        setMobileMenu,
      }}
    >
      <Analytics/>
      <Helmet>
        <html lang="ru" />
        <meta name="format-detection" content="telephone=no" />
      </Helmet>
      <Header />
      <div className="wrapper_central_section">
        <SwitchTransition>
          <CSSTransition
            nodeRef={ref}
            key={location.pathname}
            timeout={20}
            classNames="page"
          >
            <Suspense fallback={<PageLoad className={"percents"} />}>
              <div ref={ref} className="central_section">
                {currentOutlet}
              </div>
            </Suspense>
          </CSSTransition>
        </SwitchTransition>
      </div>
      <Footer />
      <ModalWindow />
    </MainLayoutContext.Provider>
  );
};

export default MainLayout;
